import React from "react";
import {
  Bar,
  XAxis,
  YAxis,
  BarChart,
  ReferenceLine,
  ResponsiveContainer,
  Cell,
} from "recharts";

export default function HoleScoringGraph({ hole, holeScores }) {
  const data = [
    { name: "EAG", value: holeScores.eagles },
    { name: "BRD", value: holeScores.birdies },
    { name: "PAR", value: holeScores.pars },
    { name: "BOG", value: holeScores.bogeys },
    { name: "DBG", value: holeScores.doubleBogeys },
    { name: "TBW", value: holeScores.tripleBogeysOrWorse },
  ];

  const barColors = {
    EAG: "#d55858",
    BRD: "#eeab55",
    PAR: "#74c273",
    BOG: "#64bedd",
    DBG: "#568bc3",
    TBW: "#6a4d73",
  };

  const windowWidth = document.body.clientWidth;

  let showAxisOn = [1, 7, 13];

  if (windowWidth < 1024) {
    showAxisOn = [1, 4, 7, 10, 13, 16];
  }

  if (windowWidth < 550) {
      showAxisOn = [1, 3, 5, 7, 9, 11, 13, 15, 17]
  }

  class CustomizedLabel extends React.Component {
    render() {
      const { x, y, width, height, fill, value } = this.props;

      if (value === 0) {
        return null;
      }

      return (
        <text
          x={x + width + 5}
          y={y + height / 2}
          dy={4}
          fontSize="16"
          fontFamily="sans-serif"
          fill="black"
          textAnchor="start"
        >
          {value}
        </text>
      );
    }
  }

  return (
    <div
      style={{
        width: showAxisOn.includes(hole.holeNum) ? "210px" : "150px",
        height: "150px",
        border: "1px solid black"
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical"
          barCategoryGap={1}
          margin={{
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
          }}
        >
          <YAxis
            type="category"
            dataKey="name"
            interval={0}
            hide={!showAxisOn.includes(hole.holeNum)}
          />
          <XAxis type="number" hide domain={["dataMin", "dataMax + 50"]} />
          <Bar dataKey="value" fill="blue" label={<CustomizedLabel />}>
            {data.map((entry, index) => {
              return (
                <Cell key={`cell-${index}`} fill={barColors[entry.name]} />
              );
            })}
          </Bar>
          <text
            x="97%"
            y="14%"
            style={{
              fontSize: 24,
              fontWeight: "bold",
              fill:
                hole.par === 3
                  ? "#c17407"
                  : hole.par === 4
                  ? "#252525"
                  : "#0000c2",
            }}
            width={200}
            textAnchor="end"
          >
            #{hole.holeNum}
          </text>
          <text
            x="97%"
            y="95%"
            style={{
              fontSize: 24,
              fontWeight: "bold",
              fill: holeScores.toParAverage < 0 ? "var(--gup-green)" : "red",
            }}
            width={200}
            textAnchor="end"
          >
            {holeScores.toParAverage}
          </text>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
